import { MapActions } from 'context/Map/types';
import { mapBalikovnaExtendedPoint } from 'helpers/balikovna';
import { BalikovnaExtendedPoint } from 'helpers/balikovna/types';
import { DpdExtendedPoint, mapDpdExtendedPoint } from 'helpers/dpd/dpd';
import { mapPacketeryExtendedPoint } from 'helpers/packetery';
import { PacketeryExtendedPoint } from 'helpers/packetery/types';
import { mapPaczkomatExtendedPoint } from 'helpers/paczkomat';
import { PaczkomatExtendedPoint } from 'helpers/paczkomat/types';
import { getPickupPointCookie, setPickupPointCookie } from 'helpers/pickupPoint/pickupPointCookie';
import { mapPplExtendedPoint, PplExtendedPoint } from 'helpers/ppl/ppl';
import { mapSearchedStoreToPickupPoint } from 'helpers/searchedStore';
import { MapMarkerType } from 'types/map';
import { ExternalPickupPointType, PickupPointType } from 'types/pickupPoint';
import { SearchedStoreType } from 'types/store';
import { MappedTransportType, TransportTypeCodeEnum } from 'types/transport';

export const mapPickupPointFromExternalPickupPoint = (
    point: ExternalPickupPointType,
    openedTransportWithPickupPointsCode: string,
    openedTransportWithPickupPointsUuid: string,
): PickupPointType | null => {
    let mappedPickupPoint = null;
    switch (openedTransportWithPickupPointsCode) {
        case TransportTypeCodeEnum.COMMON:
            mappedPickupPoint = mapSearchedStoreToPickupPoint(point as SearchedStoreType);
            break;
        case TransportTypeCodeEnum.PACKETERY:
            mappedPickupPoint = mapPacketeryExtendedPoint(point as PacketeryExtendedPoint);
            break;
        case TransportTypeCodeEnum.PACZKOMAT:
            mappedPickupPoint = mapPaczkomatExtendedPoint(point as PaczkomatExtendedPoint);
            break;
        case TransportTypeCodeEnum.BALIKOVNA:
            mappedPickupPoint = mapBalikovnaExtendedPoint(point as BalikovnaExtendedPoint);
            break;
        case TransportTypeCodeEnum.POST_OFFICE_PARCEL_DELIVERY_CZ:
            mappedPickupPoint = mapSearchedStoreToPickupPoint(point as SearchedStoreType);
            break;
        case TransportTypeCodeEnum.POST_OFFICE_PARCEL_DELIVERY_HU:
            mappedPickupPoint = mapSearchedStoreToPickupPoint(point as SearchedStoreType);
            break;
        case TransportTypeCodeEnum.POST_OFFICE_PARCEL_DELIVERY_SK:
            mappedPickupPoint = mapSearchedStoreToPickupPoint(point as SearchedStoreType);
            break;
        case TransportTypeCodeEnum.PBH:
            mappedPickupPoint = mapSearchedStoreToPickupPoint(point as SearchedStoreType);
            break;
        case TransportTypeCodeEnum.PPL:
            mappedPickupPoint = mapPplExtendedPoint(point as PplExtendedPoint);
            break;
        case TransportTypeCodeEnum.DPD:
            mappedPickupPoint = mapDpdExtendedPoint(point as DpdExtendedPoint);
            break;
        default:
            mappedPickupPoint = null;
            break;
    }

    if (mappedPickupPoint && openedTransportWithPickupPointsCode !== TransportTypeCodeEnum.COMMON) {
        setPickupPointCookie(
            mappedPickupPoint,
            openedTransportWithPickupPointsCode,
            openedTransportWithPickupPointsUuid,
        );
    }

    return mappedPickupPoint;
};

export const getIsTransportWithPickupPoint = (
    transportCode: string | null | undefined,
    isPersonalPickup: boolean,
): boolean => {
    if (!transportCode) {
        return false;
    }

    return (
        isPersonalPickup ||
        transportCode === TransportTypeCodeEnum.PACKETERY ||
        transportCode === TransportTypeCodeEnum.PACZKOMAT ||
        transportCode === TransportTypeCodeEnum.BALIKOVNA ||
        transportCode === TransportTypeCodeEnum.POST_OFFICE_PARCEL_DELIVERY_CZ ||
        transportCode === TransportTypeCodeEnum.POST_OFFICE_PARCEL_DELIVERY_HU ||
        transportCode === TransportTypeCodeEnum.POST_OFFICE_PARCEL_DELIVERY_SK ||
        transportCode === TransportTypeCodeEnum.PBH ||
        transportCode === TransportTypeCodeEnum.PPL ||
        transportCode === TransportTypeCodeEnum.DPD
    );
};

export const getPickupPointDetail = (
    transportItem: MappedTransportType,
    pickupPoint: PickupPointType | null,
): PickupPointType | null => {
    const transportCode = transportItem.transportType.code;

    if (
        getIsTransportWithPickupPoint(transportCode, transportItem.isPersonalPickup) &&
        !transportItem.isPersonalPickup
    ) {
        return getPickupPointCookie(transportCode, transportItem.uuid);
    }

    if (transportCode === TransportTypeCodeEnum.COMMON && transportItem.isPersonalPickup) {
        return pickupPoint;
    }

    return null;
};

export const getSelectedPickupPoint = (
    transport: MappedTransportType | null,
    pickupPointIdentifier: string | null | undefined,
): PickupPointType | null => {
    if (transport === null || pickupPointIdentifier === null) {
        return null;
    }
    if (
        getIsTransportWithPickupPoint(transport.transportType.code, transport.isPersonalPickup) &&
        !transport.isPersonalPickup
    ) {
        return getPickupPointCookie(transport.transportType.code, transport.uuid);
    }

    const pickupPoint = transport.stores.find((place) => place.identifier === pickupPointIdentifier);

    return pickupPoint === undefined ? null : pickupPoint;
};

export const centerOnMarkerHandler = (marker: MapMarkerType, dispatch: React.Dispatch<MapActions>) => {
    if (marker.lng && marker.lat) {
        dispatch({
            type: 'setCenter',
            payload: { lng: marker.lng, lat: marker.lat },
        });
        dispatch({
            type: 'setZoom',
            payload: 15,
        });
        dispatch({ type: 'setActiveMarkerUuid', payload: marker.identifier });
    }
};
